import { render, staticRenderFns } from "./CotizacionesModelAddComponent.vue?vue&type=template&id=2690c178&"
import script from "./CotizacionesModelAddComponent.vue?vue&type=script&lang=js&"
export * from "./CotizacionesModelAddComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports